const isMobile = document.body.offsetWidth < 799;
export default isMobile;
